export default "__VITE_ASSET__CnkKM7Wn__"